import { useContext } from "react";
import { Context } from "../../utils/main-context/MainContext";

import "./menu.scss";

const Menu = () => {
  const { menuActive, callHero, callProjects, callAbout } = useContext(Context);

  return (
    <div className={menuActive ? "menu active" : "menu"}>
      <div className="container">
        <ul className="menu-list">
          <li className="menu-item">
            <button onClick={() => callHero()}>Home</button>
          </li>
          <li className="menu-item">
            <button onClick={() => callProjects()}>Projects</button>
          </li>
          <li className="menu-item">
            <button onClick={() => callAbout()}>About me</button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Menu;
